export default "__VITE_ASSET__Dfse_$4S__"